<template>
  <div class='homePage' id='homePage' ref='homePage'>
    <div class="mobile" v-if="isMobile">
      <div class='img-wrapper'>
        <img :src='topImg'/>
        <div class="locale">
          <span v-for="(item,index) in countryList" :key="index"
                :class="$store.state.locale===item.Language?'active':''"
                @click="chooseLocale(item)">{{ item.CountryNameLocal }}</span>
        </div>
        <div class="bookmark">{{ $t('lang.signal.bookmark') }}</div>
      </div>
      <div class="apkStore">
        <div class="titleBox"><img :src="robot"/>{{ $t('lang.signal.apk') }}</div>
        <div class="storeBox">
          <div class="getExtra">{{ $t('lang.signal.extra1') }}<span style="color: #FFF27D">{{
              $t('lang.account.currencyType') + 19
            }}</span> {{ $t('lang.signal.extra2') }}
          </div>
          <div class="downLoad" @click="download">
            <div class="inner">
              <div class="innerDiv"> {{ $t('lang.common.downLoad') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="linkBox">
        <div class='link'><span class="dot"/>{{ $t('lang.signal.link') }}</div>
        <div class='signals'>
          <div class='sign-item' v-for='(item,index) in signals' :key='index'>
            <div v-if="index===2" class="gradient-tp"/>
            <div v-if="index===0" class="gradient-bt"/>
            <div class="label">{{ $t('lang.signal.line') + (index + 1) }}</div>
            <div class="signal">
              <img :src="sign" v-if="item.DnsStatus===true"/>
              <img :src="noSign" v-else/>
            </div>
            <div class="btn" @click="gotoLink(item.DomainName)">{{ $t('lang.luckyWheel.executeBtn').toUpperCase() }}</div>
          </div>
        </div>
      </div>
      <div class="followUs">
        <hr>
        {{ $t('lang.signal.follow') }}
        <hr>
      </div>
      <div class="socialDiv">
        <img :src="w" @click="goSocial(0)"/>
        <img :src="f" @click="goSocial(1)"/>
        <img :src="t" @click="goSocial(2)"/>
      </div>
      <div class="permit"><img :src="permit"/></div>
      <div class="live" @click="handelOpenChat"><img :src="live"/></div>
    </div>
    <div class="web" v-else>
      <div class='img-wrapper'>
        <img :src='topImg'/>
        <div class="locale">
          <span v-for="(item,index) in countryList" :key="index"
                :class="$store.state.locale===item.Language?'active':''"
                @click="chooseLocale(item)">{{ item.CountryNameLocal }}</span>
        </div>
        <div class="bookmark">{{ $t('lang.signal.bookmark') }}</div>
      </div>
      <div class="apkStore">
        <div class="titleBox"><img :src="robot"/>{{ $t('lang.signal.apk') }}</div>
        <div class="storeBox">
          <div class="getExtra">{{ $t('lang.signal.extra1') }}<span style="color: #FFF27D">{{
              $t('lang.account.currencyType') + 19
            }}</span> {{ $t('lang.signal.extra2') }}
          </div>
          <div class="downLoad" @click="download">
            <div class="inner">
              <div class="innerDiv"> {{ $t('lang.common.downLoad') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="linkBox">
        <div class='link'><span class="dot"/>{{ $t('lang.signal.link') }}</div>
        <div class='signals'>
          <div class='sign-item' v-for='(item,index) in signals' :key='index'>
            <div v-if="index===2" class="gradient-tp"/>
            <div v-if="index===0" class="gradient-bt"/>
            <div class="label">{{ $t('lang.signal.line') + (index + 1) * 1 }}</div>
            <div class="signal">
              <img :src="sign" v-if="item.DnsStatus===true"/>
              <img :src="noSign" v-else/>
            </div>
            <div class="btn" @click="gotoLink(item.DomainName)">{{ $t('lang.luckyWheel.executeBtn').toUpperCase() }}</div>
          </div>
        </div>
      </div>
      <div class="followUs">
        <hr>
        {{ $t('lang.signal.follow') }}
        <hr>
      </div>
      <div class="socialDiv">
        <img :src="w" @click="goSocial(0)" alt=""/>
        <img :src="f" @click="goSocial(1)" alt=""/>
        <img :src="t" @click="goSocial(2)" alt=""/>
      </div>
      <div class="permit"><img :src="permit"/></div>
      <div class="live" @click="handelOpenChat"><img :src="live"/></div>
    </div>
  </div>
</template>

<script>
import webBack from '@/assets/images/common/webBack.png'
import topImg from '@/assets/images/common/top.png'
import sign from '@/assets/images/common/sign.svg'
import noSign from '@/assets/images/common/noSign.svg'
import permit from '@/assets/images/common/permit.png'
import robot from '@/assets/images/common/robot.svg'
import robot2 from '@/assets/images/common/robot2.svg'
import live from '@/assets/images/common/live.svg'
import f from '@/assets/images/common/f.svg'
import t from '@/assets/images/common/t.svg'
import w from '@/assets/images/common/w.svg'
import {mapMutations} from 'vuex'
import {Storage} from '@/utils'
import QrcodeVue from 'qrcode.vue'
import request from '@/service'

export default {
  name: 'Home',
  components: {
    QrcodeVue
  },
  data () {
    return {
      sign,
      live,
      permit,
      noSign,
      w,
      f,
      t,
      robot,
      robot2,
      topImg,
      webBack,
      isMobile: false,
      countryList: [
        {
          'Id': 1,
          'CountryCode': 'IN',
          'CountryNameEn': 'English',
          'CountryNameLocal': 'EN',
          'Language': 'EN',
          'Active': true,
          'CreateTime': '2021-08-07T08:52:14.86'
        },
        {
          'Id': 2,
          'CountryCode': 'IN',
          'CountryNameEn': 'India',
          'CountryNameLocal': 'भारत',
          'Language': 'IN',
          'Active': true,
          'CreateTime': '2021-08-07T09:24:54.067'
        }
      ],
      qrSize: 30,
      downUrl: '',
      signals: [],
      urls: [
        'https://www.whatsapp.com/channel/0029VaLYDIyJUM2iM7A5Xp0L',
        'https://www.facebook.com/BetAjayofficial/',
        'https://t.me/BetAjay_official'
      ]
    }
  },
  watch: {},
  mounted () {
    this.visitNav()
    this.getData()
    this.fetchVisitMachine()
    window.addEventListener('resize', this.fetchVisitMachine)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.fetchVisitMachine)
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    handelOpenChat () {
      window.LiveChatWidget.call('maximize')
    },
    visitNav: function () {
    },
    getData () {
      request('get', '/innovation/get/portal/domain/list?pageNo=1&pageSize=10')
        .then(res => {
          const records = res.result.records
          // 随机抽样
          const getRandomSample = (arr, size) => {
            return [...arr]
              .sort(() => Math.random() - 0.5) // 随机打乱顺序
              .slice(0, size)
          }

          this.signals = records.length >= 3 ? getRandomSample(records, 3) : records
          this.getDownUrl()
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchVisitMachine () {
      this.qrSize = window.innerWidth * 0.06
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    chooseLocale (internation) {
      this.showCountryDDL = !this.showCountryDDL
      this.setInternation(internation.CountryCode)
      // 2021-10-31 CHP 增加设置国家版本名字、语言
      this.setInternationName(internation.CountryNameLocal)
      localStorage.setItem('locale', internation.Language)
      localStorage.setItem('internationName', internation.CountryNameLocal)
      this.locale = internation.Language
      this.internationName = internation.CountryNameLocal
      this.$i18n.locale = internation.Language // localStorage.getItem('locale') // todo 切换版本
      this.$store.commit('setLocale', internation.Language)
      Storage.setExpire('locale', internation.Language, 7 * 24 * 3600)
    },
    download () {
      window.location.href = this.downUrl
    },
    getDownUrl () {
      const signal = this.signals.find(item => item.DnsStatus === true)
      if (signal && signal.DomainName) {
        let base = 'https://api.' + signal.DomainName
        this.downUrl = base + '/mobileapp/betajay-' + signal.Channel + '-' + signal.Version + '.apk'
      }
    },
    gotoLink (link) {
      let end = window.location.search ? window.location.search : ''
      if (this.isMobile) {
        window.location.href = 'https://app.' + link + end
      } else {
        window.location.href = 'https://www.' + link + end
      }
    },
    goSocial (index) {
      window.open(this.urls[index])
    }
  }
}
</script>

<style lang='less' scoped>
.homePage {
  height: 100vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  background: #120D0D;

  .mobile {
    position: relative;
    top: 0;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;

    .img-wrapper {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 100vw;

      img {
        width: 100%;
      }

      .locale {
        position: absolute;
        top: 6.667vw;
        left: 6.11vw;
        width: 24.722vw;
        height: 7.5vw;
        border-radius: 5vw;
        background: rgba(0, 0, 0, 0.68);
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: 4.166vw;
        font-weight: 400;
        text-align: center;
      }

      .bookmark {
        position: absolute;
        top: 50vw;
        left: 50%;
        transform: translate(-50%);
        text-align: center;
        font-size: 4.444vw;
        font-weight: 400;
        letter-spacing: 0.06em;
        color: #646464;
        text-shadow: 0 -0.8px 0px #4A4A4A;
      }

      img {
        width: 100%;
      }
    }

    .apkStore {
      position: relative;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      width: 92.222vw;
      height: 46.944vw;
      border-radius: 2.222vw;
      box-shadow: 0 0 4.8px 0 rgba(0, 0, 0, 0.08);
      background: radial-gradient(50% 50% at 50% 50%, #161111 0%, #201E1E 100%),
      linear-gradient(180deg, #241E19 0%, #232323 100%);

      .titleBox {
        width: 100%;
        height: 13.888vw;
        text-align: center;
        background: linear-gradient(90deg, #E4D272 0%, #EAB668 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-size: 5.277vw;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 1vw;

        img {
          height: 5.277vw;
          margin-right: 2vw;
          margin-bottom: 0.5vw;
        }
      }

      .storeBox {
        position: relative;
        left: 50%;
        top: 2vw;
        transform: translate(-50%);
        width: 86.111vw;
        height: 27.222vw;
        background: radial-gradient(50% 97.52% at 50% 50%, #241C1C 0%, #110E0E 100%);
        padding-top: 3vw;
        border-radius: 2.222vw;

        .getExtra {
          margin-bottom: 2vw;
          text-align: center;
          font-size: 5vw;
          font-weight: 700;
          letter-spacing: -0.01em;
          color: #D9D9D9;
        }

        .downLoad {
          position: relative;
          margin: 2vw auto;
          width: 77.65vw;
          height: 12.222vw;
          line-height: calc(12.222vw - 12px);
          border-radius: 2.222vw;
          text-align: center;
          color: #000000;
          font-size: 5.833vw;
          font-weight: 700;
          background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
          animation: zoom 250ms ease-in-out infinite alternate;

          .inner {
            position: absolute;
            top: 2px;
            left: 2px;
            bottom: 2px;
            right: 2px;
            border-radius: calc(2.222vw - 2px);
            background: #000000;
            padding: 4px;

            .innerDiv {
              width: 100%;
              height: 100%;
              border-radius: calc(2.222vw - 4px);
              background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
            }
          }
        }
      }

      @keyframes zoom {
        0% {
          transform: scale(0.9);
        }
        100% {
          transform: scale(1); /* 放大倍数可根据需要调整 */
        }
      }

    }

    .linkBox {
      background: linear-gradient(180deg, #161212 0%, #1B1313 110.23%);

      .link {
        position: relative;
        left: 50%;
        top: 3.6vw;
        transform: translate(-50%);
        width: 92.222vw;
        height: 11.55vw;
        line-height: 11.55vw;
        padding-left: 5vw;
        text-align: left;
        font-size: 5.55vw;
        font-weight: 700;
        color: #FFFFFF;
        background: linear-gradient(180deg, #1C1C1C 0%, #201E1C 55.5%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .dot {
          width: 1.666vw;
          height: 1.666vw;
          background-color: #F0D55E;
          border-radius: 50%;
          display: inline-block;
          margin-left: -1vw;
          margin-right: 2vw;
        }
      }

      .signals {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        text-align: center;
        width: 92.222vw;
        height: 40vw;
        border-radius: 2.222vw;
        padding: 2vw 0;

        .sign-item {
          position: relative;
          padding: 0 4.722vw;
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          height: 13.333vw;

          .label {
            font-size: 5vw;
            font-weight: 700;
            text-align: left;
            color: #FFFFFF;
          }

          .signal {
            margin-left: 18.5vw;

            img {
              width: 5vw;
            }
          }

          .btn {
            background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
            width: 102px;
            height: 7.777vw;
            line-height: 7.777vw;
            border-radius: 3px;
            text-align: center;
            color: #0C0C0C;
            font-size: 4.444vw;
            font-weight: 700;
            letter-spacing: -0.01em;
            cursor: pointer;
          }

          .gradient-bt {
            position: absolute;
            bottom: -3vw;
            left: 50%;
            transform: translate(-50%);
            background: #222121;
            width: 100%;
            height: 0.555vw;
          }

          .gradient-tp {
            position: absolute;
            top: 2.5vw;
            background: #222121;
            left: 50%;
            transform: translate(-50%);
            width: 100%;
            height: 0.555vw;
          }
        }

      }
    }

    .followUs {
      position: relative;
      top: 10vw;
      left: 50%;
      transform: translate(-50%);
      display: flex;
      width: 83vw;
      background: linear-gradient(90deg, #E4D272 0%, #EAB668 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-size: 5.277vw;
      font-weight: 700;
      text-align: center;
      justify-content: space-between;
      align-items: center;

      hr {
        width: 25.555vw;
        height: 0;
        border: 0.5vw solid #2E2E2E;
      }

      img {
        margin-right: 2.5vw;
        width: 4.444vw;
      }
    }

    .socialDiv {
      position: relative;
      top: 15vw;
      left: 50%;
      transform: translate(-50%);
      width: 92.222vw;
      height: 21.944vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2.777vw 15.555vw 0 15.555vw;
      border-radius: 2.222vw;
      background: linear-gradient(180deg, #1A1A1C 0%, #1F1D1A 55.5%);

      img {
        height: 16.388vw;
      }
    }

    .permit {
      position: relative;
      top: 16.2vw;
      left: 50%;
      transform: translate(-50%);
      width: 100vw;
      height: 20.964vw;

      img {
        width: 100%;
      }
    }

    .live {
      position: fixed;
      top: 9.722vw;
      right: 0;
      height: 13.611vw;

      img {
        width: 100%;
      }
    }

    .active {
      color: #B8B0B0;
      font-weight: 700;
    }
  }

  .web {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: 360px;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;

    .img-wrapper {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 360px;

      img {
        width: 100%;
      }

      .locale {
        position: absolute;
        top: calc(6.667 * 3.6px);
        left: calc(6.11 * 3.6px);
        width: calc(24.722 * 3.6px);
        height: calc(7.5 * 3.6px);
        border-radius: calc(5 * 3.6px);
        background: rgba(0, 0, 0, 0.68);
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: calc(4.166 * 3.6px);
        font-weight: 400;
        text-align: center;
        cursor: pointer;
      }
      .bookmark {
        position: absolute;
        top: 180px;
        left: 50%;
        transform: translate(-50%);
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.06em;
        color: #646464;
        text-shadow: 0 -0.8px 0px #4A4A4A;
      }

      img {
        width: 100%;
      }
    }

    .apkStore {
      position: relative;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      width: calc(92.222 * 3.6px);
      height: calc(46.944 * 3.6px);
      border-radius: calc(2.222 * 3.6px);
      box-shadow: 0 0 4.8px 0 rgba(0, 0, 0, 0.08);
      background: radial-gradient(50% 50% at 50% 50%, #161111 0%, #201E1E 100%),
      linear-gradient(180deg, #241E19 0%, #232323 100%);

      .titleBox {
        width: 100%;
        height: calc(13.888 * 3.6px);
        text-align: center;
        background: linear-gradient(90deg, #E4D272 0%, #EAB668 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-size: calc(5.277 * 3.6px);
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: calc(1 * 3.6px);

        img {
          height: calc(5.277 * 3.6px);
          margin-right: calc(2 * 3.6px);
          margin-bottom: calc(0.5 * 3.6px);
        }
      }

      .storeBox {
        position: relative;
        left: 50%;
        top: calc(2 * 3.6px);
        transform: translate(-50%);
        width: calc(86.111 * 3.6px);
        height: calc(27.222 * 3.6px);
        background: radial-gradient(50% 97.52% at 50% 50%, #241C1C 0%, #110E0E 100%);
        padding-top: calc(3 * 3.6px);
        border-radius: calc(2.222 * 3.6px);

        .getExtra {
          margin-bottom: calc(2 * 3.6px);
          text-align: center;
          font-size: calc(5 * 3.6px);
          font-weight: 700;
          letter-spacing: -0.01em;
          color: #D9D9D9;
        }

        .downLoad {
          position: relative;
          margin: calc(2 * 3.6px) auto;
          width: calc(77.65 * 3.6px);
          height: calc(12.222 * 3.6px);
          line-height: 32px;
          border-radius: calc(2.222 * 3.6px);
          text-align: center;
          color: #000000;
          font-size: calc(5.833 * 3.6px);
          font-weight: 700;
          background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
          animation: zoom 250ms ease-in-out infinite alternate;
          cursor: pointer;

          .inner {
            position: absolute;
            top: 2px;
            left: 2px;
            bottom: 2px;
            right: 2px;
            border-radius: 6px;
            background: #000000;
            padding: 4px;

            .innerDiv {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
            }
          }
        }
      }

      @keyframes zoom {
        0% {
          transform: scale(0.9);
        }
        100% {
          transform: scale(1); /* 放大倍数可根据需要调整 */
        }
      }

    }

    .linkBox {
      background: linear-gradient(180deg, #161212 0%, #1B1313 110.23%);

      .link {
        position: relative;
        left: 50%;
        top: calc(3.6 * 3.6px);
        transform: translate(-50%);
        width: calc(92.222 * 3.6px);
        height: calc(11.55 * 3.6px);
        line-height: calc(11.55 * 3.6px);
        padding-left: calc(5 * 3.6px);
        text-align: left;
        font-size: calc(5.55 * 3.6px);
        font-weight: 700;
        color: #FFFFFF;
        background: linear-gradient(180deg, #1C1C1C 0%, #201E1C 55.5%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .dot {
          width: 6px;
          height: 6px;
          background-color: #F0D55E;
          border-radius: 50%;
          display: inline-block;
          margin-left: -3.6px;
          margin-right: 7.2px;
        }
      }

      .signals {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        text-align: center;
        width: calc(92.222 * 3.6px);
        height: calc(40 * 3.6px);
        border-radius: calc(2.222 * 3.6px);
        padding: calc(2 * 3.6px) 0;

        .sign-item {
          position: relative;
          padding: 0 calc(4.722 * 3.6px);
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          height: calc(13.333 * 3.6px);

          .label {
            font-size: calc(5 * 3.6px);
            font-weight: 700;
            text-align: left;
            color: #FFFFFF;
          }

          .signal {
            margin-left: calc(18.5 * 3.6px);

            img {
              width: calc(5 * 3.6px);
            }
          }

          .btn {
            background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
            width: 102px;
            height: calc(7.777 * 3.6px);
            line-height: calc(7.777 * 3.6px);
            border-radius: 3px;
            text-align: center;
            color: #0C0C0C;
            font-size: calc(4.444 * 3.6px);
            font-weight: 700;
            letter-spacing: -0.01em;
            cursor: pointer;
          }

          .gradient-bt {
            position: absolute;
            bottom: -10.8px;
            left: 50%;
            transform: translate(-50%);
            background: #222121;
            width: 100%;
            height: 2px;
          }

          .gradient-tp {
            position: absolute;
            top: 9px;
            background: #222121;
            left: 50%;
            transform: translate(-50%);
            width: 100%;
            height: 2px;
          }
        }

      }
    }

    .followUs {
      position: relative;
      top: 36px;
      left: 50%;
      transform: translate(-50%);
      display: flex;
      width: calc(83 * 3.6px);
      background: linear-gradient(90deg, #E4D272 0%, #EAB668 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-size: calc(5.277 * 3.6px);
      font-weight: 700;
      text-align: center;
      justify-content: space-between;
      align-items: center;

      hr {
        width: calc(25.555 * 3.6px);
        height: 0;
        border: calc(0.5 * 3.6px) solid #2E2E2E;
      }

      img {
        margin-right: calc(2.5 * 3.6px);
        width: calc(4.444 * 3.6px);
      }
    }

    .socialDiv {
      position: relative;
      top: calc(15 * 3.6px);
      left: 50%;
      transform: translate(-50%);
      width: calc(92.222 * 3.6px);
      height: 79px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 56px 0 56px;
      border-radius: calc(2.222 * 3.6px);
      background: linear-gradient(180deg, #1A1A1C 0%, #1F1D1A 55.5%);

      img {
        height: 59px;
        cursor: pointer;
      }
    }

    .permit {
      position: relative;
      top: calc(16.2 * 3.6px);
      left: 50%;
      transform: translate(-50%);
      width: calc(100 * 3.6px);
      height: calc(20.964 * 3.6px);

      img {
        width: 100%;
      }
    }

    .live {
      position: fixed;
      top: calc(9.722 * 3.6px);
      right: 0;
      height: calc(13.611 * 3.6px);
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .active {
      color: #B8B0B0;
      font-weight: 700;
    }
  }

  .web::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue